<div class="my-4 form-error-details rounded-2xl p-4 flex justify-start gap-4 items-center" @fadeInOutWithBlur
  *ngIf="displayError && formFieldsErrors.length>0">
  <div class="w-fit">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
      stroke-linecap="round" stroke-linejoin="round" class="w-16 h-16">
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
      <path d="M12 8v4" />
      <path d="M12 16h.01" />
    </svg>
  </div>
  <div class="w-full p-2">
    <span class="text-xl font-semibold">Errori nella validazione del form</span>

    @for (item of formFieldsErrors; track $index) {
    <div class="flex flex-col gap-1 user-card bg-primary-50 rounded-2xl p-2">
      <div class="flex gap-2 items-center">
        <div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z" />
          </svg></div>
        <div>
          <b>{{item.title}}</b>
        </div>
      </div>
      <div class="ml-2">
        {{item.details}}
      </div>
    </div>
    }

  </div>
</div>
<!-- align-middle justify-center content-center -->
<form #theForm [formGroup]="form" (submit)="onSubmit($event)">
  <div
    class="dynamic-form flex {{options && options.areas && options.areas.length > 1 ? 'flex-wrap  w-full items-stretch' : 'flex-col'}} mx-auto ">

    @for(area of (options && options.areas ? options.areas : defaultArea); track
    $index){
  
    <div *ngIf="getFieldInArea($index+1).length > 0" class="flex flex-col p-1 py-4 box-border {{ isMobile ? 'w-full' : (area.width != undefined ? area.width : 'w-full')}} " >

      <div class="{{options && options.areas && options.areas.length > 1 ? 'p-1 bg-slate-300/25 justify-start items-start h-full user-card rounded-2xl': ''}} w-full {{area.cssClass}}">
        
        <p *ngIf="area.name" class="text-center text-2xl font-bold text-colored">{{area.name}}</p>
        <div class="flex flex-wrap">

          <div @fadeInOutWithBlur *ngFor="let field of getFieldInArea($index+1)"
            [ngClass]="{'hidden':field.type=='button' || field.hidden== true }"
            class="{{field.width || 'w-1/2'}} px-2 field-dynamic ">

            <div *ngIf="field.type!='button'" class="transform duration-300 " appDynamicField [field]="field"
              [group]="form" (onNoSubmitClick)="noSumitClick($event)" (onButtonMenuClick)="buttonMenuClick($event)"
              (onFieldChange)="onFieldChange($event)" (onInputChange)="inputChange($event)"
              (onSelectChangeEvent)="selectChange($event)" (onSwitchChange)="switchChange($event)"
              (onCheckBoxChange)="checkBoxChange($event)" (onKeyUp)="onKeyUpInput($event)"
              (valueChangedEvent)="multiLazyChanges($event)" [getDataSource]="getDataSource" [updateDataSource]="updateDataSource" (sendDataSourceDropdown)="sendDataSourceOfDropdown($event)" (dropdownDataSourceReady)="dropdownDataSourceReady.emit($event)">
            </div>

            <div *ngIf="field.type=='embed'" [class]="field.hidden ? 'invisible' : ''">
              <ng-template [ngTemplateOutlet]="field.embedRef!"></ng-template>
            </div>
            <!-- <p *ngIf="field.message && field.message!.length>0" class="font-bold text-red-500">{{field.message}}</p> -->


          </div>
          <!--</div>-->
        </div>

      </div>
    </div>
    }
    <!-- Buttons -->
    @if(parsedOptions.buttonAtBottom == false) {
    <div [ngClass]="'flex flex-wrap mt-4 '">
      <ng-container *ngFor="let field of fields;" class="grow {{field.width}} ">
        <div *ngIf="field.type==='button'" class="pr-4 grow {{field.width}}">
          <div appDynamicField [field]="field" [group]="form" class="grow {{field.width}}"
            (onNoSubmitClick)="noSumitClick($event)" (onButtonMenuClick)="buttonMenuClick($event)"
            (onFieldChange)="onFieldChange($event)" (onInputChange)="inputChange($event)"
            (onSelectChangeEvent)="selectChange($event)" (onSwitchChange)="switchChange($event)"
            (onCheckBoxChange)="checkBoxChange($event)" (onMultiLazyChanges)="multiLazyChanges($event)"
            (onRadioChange)="checkBoxChange($event)"></div>
        </div>
      </ng-container>
    </div>
    }@else if (returnActiveButtons() > 0) {





    <div [ngStyle]="{
      'left': isMobile
      ? 'auto'
      : (sidebarOpen ? 'calc(50% + 155px)' : '50%'),
    right:'1rem',
    transform: !isMobile ?( buttonBarOpen ? 'translateX(-50%)' : 'translateX(60%)'):'none',
    'z-index': '998',
    width: (isMobile ? '95%' : (sidebarOpen ? 'calc(80% - 310px)' : 'calc(80% - 100px)'))
      
      }" style="white-space: nowrap;"
      class="flex {{!isMobile ? 'justify-start' : 'justify-end'}} items-center gap-2 p-2   fixed bottom-4 transition-all duration-700 text-center overflow-none rounded-full {{buttonBarOpen ?'bg-white/40 backdrop-blur-3xl  shadow-lg ' : ''}}">

      <div @fadeInOutWithBlur *ngIf="buttonBarOpen"
        class="flex gap-2 transition-all text-center  w-full overflow-none ">
        <ng-container *ngFor="let field of fields;" class="grow {{field.width}} overflow-none ">
          <div *ngIf="field.type === 'button'" class=" grow {{ field.width }}">
            <div appDynamicField [field]="field" [group]="form" class="grow {{ field.width }}"
              (onNoSubmitClick)="noSumitClick($event)" (onButtonMenuClick)="buttonMenuClick($event)"
              (onFieldChange)="onFieldChange($event)" (onInputChange)="inputChange($event)"
              (onSelectChangeEvent)="selectChange($event)" (onSwitchChange)="switchChange($event)"
              (onCheckBoxChange)="checkBoxChange($event)" (onMultiLazyChanges)="multiLazyChanges($event)"
              (onRadioChange)="checkBoxChange($event)"></div>
          </div>
        </ng-container>

      </div>
      <!-- <div (click)="expandCollapseButtonBar()" tabindex="0"
        class="p-2 text-primary-500 {{!buttonBarOpen ? 'bg-primary-500 text-white' : ''}} backdrop-blur-xl rounded-full flex gap-2 justify-center transition-all duration-300 items-center cursor-pointer hover:text-white hover:bg-blue-500">
        <div class="relative w-6 h-6">

          <svg *ngIf="!buttonBarOpen" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
            class="w-full h-full absolute top-0 left-0">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M15 6l-6 6l6 6" />
          </svg>

          <svg *ngIf="buttonBarOpen" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
            class="w-full h-full absolute top-0 left-0">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M9 6l6 6l-6 6" />
          </svg>

        </div>

      </div> -->



    </div>




    }

    <!-- <div [ngClass]="' flex flex-row justify-center content-center mt-2 '+parsedOptions.size">
    <div *ngFor="let field of fields;" class="{{field.name}}">
      <div *ngIf="field.type==='button' && field.name=='elimina'" appDynamicField [field]="field" [group]="form"
        (onNoSubmitClick)="noSumitClick($event)" (onButtonMenuClick)="buttonMenuClick($event)"
        (onFieldChange)="onFieldChange($event)" (onInputChange)="inputChange($event)"
        (onSelectChangeEvent)="selectChange($event)" (onSwitchChange)="switchChange($event)"
        (onCheckBoxChange)="checkBoxChange($event)"></div>

    </div> -->

  </div>

</form>

@if(options &&  options.formType == 'edit') {

  <app-custom-overlay-messagge #deleteDialog>
  
  </app-custom-overlay-messagge>
}


<app-custom-overlay-messagge #exitDialog>
  
</app-custom-overlay-messagge>